module.exports = __webpack_public_path__ + "img/card.595f756c.png";